import QrPage from "./QrPage";

export {QrPage}
export default QrPage
